module.exports = __webpack_public_path__ + "img/Smoky Stack.4d785057.png";